export type ProviderDisclaimerModel = {
  acceptance_required?: boolean,
  cache_key?: number,
  disclaimer_text?: string,
  entity_id?: number,
  entity_type?: string,
  id?: number,
  provider_id?: number,
}

export type ProviderDisclaimerRequestOptions = {}

const state = {
  acceptance_required: false,
  disclaimer_text: '',
  entity_id: undefined,
  entity_type: '',
  id: null,
  provider_id: undefined,
}

export const requiredFields = [
  { key: 'disclaimer_text' },
  { key: 'entity_id' },
  { key: 'entity_type' },
  { key: 'provider_id' },
]

export default state
